import { connect } from "react-redux";
import InlineLoading from "../../../../../components/Loading/Loading";
import MonthlyProfitAndLoss from "../../../../../models/financials/MonthlyProfitAndLoss";
import BVASelect from "../../../../../components/BVASelect/BVASelect";
import { useState } from "react";
import MonthlyProfitAndLossEbitda from "./MonthlyProfitAndLossEbitda";
import YearlyProfitAndLossEbitda from "./YearlyProfitAndLossEbitda";

const MONTHLY_VISUALIZATION_OTPION = "MONTHLY_VISUALIZATION_OTPION";
const YEARLY_VISUALIZATION_OTPION = "YEARLY_VISUALIZATION_OTPION";

const visualizationOptions = [
  { label: "Monthly", value: MONTHLY_VISUALIZATION_OTPION },
  { label: "Yearly", value: YEARLY_VISUALIZATION_OTPION },
];

function ProfitAndLossEBITDA({ currentCompanyMonthlyProfitAndLoss }) {
  const [selectedVisualization, setSelectedVisualization] = useState(
    MONTHLY_VISUALIZATION_OTPION
  );

  if (!(currentCompanyMonthlyProfitAndLoss instanceof MonthlyProfitAndLoss)) {
    return <InlineLoading />;
  }

  return (
    <div className="pb-10">
      <div className="flex items-center">
        <h2 className="text-xl font-bold">EBITDA As Defined</h2>
        <div className="ml-4">
          <BVASelect
            items={visualizationOptions}
            value={selectedVisualization}
            onChange={(visualiation) => setSelectedVisualization(visualiation)}
          />
        </div>
      </div>
      {selectedVisualization === MONTHLY_VISUALIZATION_OTPION ? (
        <MonthlyProfitAndLossEbitda />
      ) : (
        <YearlyProfitAndLossEbitda />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyMonthlyProfitAndLoss:
    state.financials.currentCompanyMonthlyProfitAndLoss,
});

export default connect(mapStateToProps)(ProfitAndLossEBITDA);
